import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as BP from '@blueprintjs/core'
import { Select } from '@blueprintjs/select'

import { enableLevel, disableLevel } from 'src/store/modules/ui/runbookgraph'

class DepthSelector extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}

        // Set the state corresponding to how many layers we have
        const { maxDepth } = this.props
        for (let i = 0; i <= maxDepth; i++) {
            this.state[i] = true
        }
    }

    componentDidMount() {
        // Enable all levels on first render
        const { maxDepth } = this.props
        for (let i = 0; i <= maxDepth; i++) {
            this.props.actions.enableLevel(i)
        }
    }

    handleCheckboxState = (e) => {
        // Set the state correctly for target checkbox
        var target = e.target.value
        this.setState({ [target]: e.target.checked })

        // Enable or disable the corresponding level
        if (e.target.checked === true) {
            this.props.actions.enableLevel(parseInt(e.target.value, 10))
        } else {
            this.props.actions.disableLevel(parseInt(e.target.value, 10))
        }
    }

    render() {
        const { maxDepth } = this.props

        return (
            <Select
                items={[...Array(maxDepth + 1).keys()]}
                itemRenderer={(item, { handleClick, modifiers }) => (
                    <BP.Checkbox
                        key={item}
                        value={item}
                        checked={this.state[item]}
                        onChange={this.handleCheckboxState}
                    >
                        {`Level ${item}`}
                    </BP.Checkbox>
                )}
                filterable={false}
            >
                <BP.Button text="Set Depth" rightIcon="double-caret-vertical" />
            </Select>
        )
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        dispatch,
        actions: bindActionCreators(
            {
                enableLevel,
                disableLevel,
            },
            dispatch
        ),
    }
}

export default connect(null, mapDispatchToProps)(DepthSelector)
